<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="user-info" @click="goToProfil()">
      <div class="profile row">
        <div class="col-xs-12 col-md-6 col-lg-4 col-4 image_profile">
          <img
            v-lazy="image_url + this.$store.getters.auth.image.cropped"
            alt=""
          />
        </div>
        <div
          v-if="$store.getters.marchand"
          class="col-xs-12 col-md-6 col-8 col-lg-8 text-left text-profile"
        >
          <span
            class="designation"
            v-b-tooltip.hover
            :title="
              $store.getters.auth._first_name && $store.getters.auth._last_name
                ? $store.getters.auth._first_name +
                  ' ' +
                  $store.getters.auth._last_name
                : $store.getters.auth._email
            "
            >{{
              setTextToUpperCase(
                limiText(
                  $store.getters.auth._first_name &&
                    $store.getters.auth._last_name
                    ? $store.getters.auth._first_name +
                        " " +
                        $store.getters.auth._last_name
                    : $store.getters.auth._email,
                  15
                )
              )
            }}</span
          ><br />
          <span class="role-profile">
            <span v-if="$store.getters.marchand">
              <v-chip
                v-b-tooltip.hover
                :title="$t('account_status_valid')"
                v-if="$store.getters.marchand._valide"
                color="#CEEDDF"
                style="height: 25px !important"
                text-color="#31AF60"
                ><strong class="success-text">
                  <v-icon color="#31AF60" style="margin-top: -3px" small
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <span class="text-uppercase"> actif </span></strong
                >
              </v-chip>
              <v-chip
                v-else
                v-b-tooltip.hover
                :title="$t('account_status_invalid')"
                color="#FFC961"
                text-color="#4a4a4a"
                ><strong
                  class="warning-text text-uppercase"
                  style="
                    height: 25px !important;
                    line-height: 28px;
                    color: #fff;
                  "
                >
                  <v-icon color="orange" style="margin-top: -3px" small
                    >mdi-minus-circle</v-icon
                  >
                  inactif</strong
                >
              </v-chip>
            </span>
          </span>
        </div>
        <div
          v-else
          class="col-xs-12 col-md-6 col-8 col-lg-8 text-left text-profile"
        >
          <span class="designation">{{
            setTextToUpperCase(
              limiText(getUserNames() || $store.getters.auth._email, 10)
            )
          }}</span
          ><br />
          <span class="role-profile">
            {{
              setTextToUpperCase(limiText($store.getters.auth.role._label, 10))
            }}</span
          >
        </div>
      </div>
    </div>

    <div
      style="background: #29b3a6; color: #fff"
      class="pt-4 pb-4 marchand-account-change"
      v-if="$store.getters.marchand"
    >
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            class="col-12"
            style="padding: 0px 10px"
          >
            <div class="text-uppercase pt-0 pb-1" style="font-size: 10px">
              Compte Business
            </div>
            <span
              v-b-tooltip.hover
              :title="$store.getters.marchand ? $t('menus.tooltip') : ''"
            >
              {{
                $store.getters.marchand
                  ? setTextToUpperCase($store.getters.marchand._company)
                  : "-"
              }}
              <span
                v-if="$store.getters.marchand"
                class="mdi mdi-chevron-down"
              ></span
            ></span>
          </div>
        </template>

        <v-list v-if="$store.getters.marchand">
          <v-subheader
            style="background: #f8f8f8; cursor: pointer"
            @click="newMarchand()"
            :title="$t('menus.addBusiness')"
          >
            <span class="mdi mdi-plus-circle-outline"></span> &nbsp;
            {{ $t("add_account") }}
          </v-subheader>

          <v-list-item-group
            color="primary"
            v-for="(item, index) in allmarchands"
            :key="index"
          >
            <v-list-item
              @click="
                $store.getters.marchand._id === item._id
                  ? ''
                  : ChangedMarchand(item._id)
              "
              :style="{
                color:
                  $store.getters.marchand._id === item._id ? '#29B3A6' : '',
              }"
            >
              <v-list-item-title
                ><span class="text-uppercase" style="font-size: 13px"
                  >{{ item._company }}
                  <span v-if="$store.getters.marchand._id === item._id"
                    >(actif)</span
                  >
                </span></v-list-item-title
              >
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </div>

    <div
      class="mode_box"
      style="
        background: transparent;
        padding: 10px !important;
        margin-bottom: 0 !important;
      "
      v-if="this.$store.getters.marchand"
    >
      <div style="text-align: center !important; padding: 0">
        <span
          ><v-btn
            @click="
              $store.getters.marchand._env === 'live'
                ? changemode('sandbox')
                : ''
            "
            min-width="70"
            small
            :color="
              this.$store.getters.marchand._env === 'sandbox'
                ? 'orange '
                : 'default'
            "
            v-b-tooltip
            :title="
              $store.getters.marchand._env === 'live'
                ? $t('menus.goToTest')
                : ''
            "
            :class="
              this.$store.getters.marchand._env === 'sandbox'
                ? 'f7-elevation-7'
                : 'disabled'
            "
            :style="
              this.$store.getters.marchand._env === 'sandbox'
                ? 'z-index:99999; box-shadow:  0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12)  !important;'
                : 'background:#f3f4f5!important;color:#787878!important;'
            "
            class="no-uppercase"
            style="margin-bottom: 0 !important; border-radius: 50px"
          >
            <v-icon
              color="white"
              v-if="this.$store.getters.marchand._env === 'sandbox'"
              small
              style="margin-right: 5px"
              >mdi-checkbox-marked-circle</v-icon
            >
            Test</v-btn
          ></span
        >
        <span
          ><v-btn
            @click="
              $store.getters.marchand._valide
                ? $store.getters.marchand._env === 'sandbox'
                  ? changemode('live')
                  : ''
                : ''
            "
            min-width="70"
            small
            :color="
              this.$store.getters.marchand._env === 'live'
                ? 'success '
                : 'default'
            "
            v-b-tooltip.hover
            :title="
              $store.getters.marchand._valide
                ? $store.getters.marchand._env === 'sandbox'
                  ? $t('menus.goToLive')
                  : ''
                : $t('menus.activeLive')
            "
            :class="
              this.$store.getters.marchand._env === 'sandbox'
                ? 'f7-elevation-7'
                : 'disabled'
            "
            style="
              margin-left: -20px;
              margin-bottom: 0 !important;
              border-radius: 50px;
            "
            class="no-uppercase"
            :style="
              this.$store.getters.marchand._env === 'live'
                ? 'z-index:99999; box-shadow:  0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12)  !important;'
                : 'background:#e9e6e6!important;color:#787878!important;'
            "
          >
            <v-icon
              color="white"
              left
              v-if="this.$store.getters.marchand._env === 'live'"
              small
              >mdi-checkbox-marked-circle</v-icon
            >
            Live</v-btn
          ></span
        >
      </div>
      <!-- Test &nbsp;&nbsp;&nbsp; <b-form-checkbox @click="changemode(this.$store.getters.marchand._env==='live' ? 'live' : 'test')" v-model="checked" name="check-button"  switch style="display:inline-block"> </b-form-checkbox> Live -->
    </div>
    <ul class="nav" id="menuNav" style="border-top: 1px solid #29b3a6">
      <!--main pages start-->

      <li
        v-if="$can('browse', 'Dashboard')"
        class="nav-item"
        :class="[currentPage === 'dashboard' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'dashboard' }">
          <i class="mdi mdi-view-dashboard menu-icon"></i>
          <span class="menu-title">{{ $t("menus.dashboard") }}</span>
        </router-link>
      </li>

      <!-- <li v-if="this.$store.getters.marchand" class="nav-item" :class="[currentPage==='reversements.configs'?'active':'']">
             <router-link class="nav-link"  :to="{name:'reversements.configs'}">
                 <i class="mdi mdi-cash-refund menu-icon"></i>
                 <span class="menu-title">{{$t('menus.reversements_configs')}}</span>
             </router-link>
         </li>-->
      <!-- <li v-if="($store.getters.marchand && $store.getters.marchand._env==='live')" class="nav-item" :class="[currentPage==='recharges'?'active':'']">
            <router-link class="nav-link"  :to="{name:'recharges'}">
                <i class="mdi mdi-credit-card-check menu-icon"></i>
                <span class="menu-title">{{$t('menus.recharges')}}</span>
            </router-link>
        </li>-->
      <!--<li v-if="($can('browse', 'Adminreversements'))" class="nav-item" :class="[currentPage==='adminreversements.configs'?'active':'']">
            <router-link class="nav-link"  :to="{name:'adminreversements.configs'}">
                <i class="mdi mdi-cash-refund menu-icon"></i>
                <span class="menu-title">{{$t('menus.reversements_configs')}}</span>
            </router-link>
        </li>-->
      <li
        v-if="
          $store.getters.marchand && $store.getters.marchand._env === 'live'
        "
        class="nav-item"
        :class="[currentPage === 'reversements.get' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'reversements.get' }">
          <i class="mdi mdi-cash-refund menu-icon"></i>
          <span class="menu-title">{{ $t("menus.reversements") }}</span>
        </router-link>
      </li>
      <li
        class="nav-item"
        :class="[currentPage === 'transactions' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'transactions' }">
          <i class="mdi mdi-cash-multiple menu-icon"></i>
          <span class="menu-title">{{ $t("menus.transactions") }}</span>
        </router-link>
      </li>
      <!--  <li v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="nav-item" >
            <a class="nav-link" data-toggle="collapse" href="#traMenu" aria-expanded="false"  aria-controls="layoutsSubmenu2" style="background: transparent!important;color: #0D0A0A!important;">
                <i class="mdi mdi-transfer  menu-icon"></i>
                <span class="menu-title">{{$t('menus.transferts')}}</span>
                <i class="mdi mdi-chevron-down menu-arrow"></i>
            </a>
            <div class="collapse" id="traMenu">
                <ul class="nav flex-column sub-menu">
  
                    <li  class="nav-item" :class="[currentPage==='transferts_general'?'active':'']">
                        <router-link class="nav-link" :to="{name:'transferts_general'}"><i class="mdi mdi-transfer menu-icon"></i>{{$t('menus.transferts_client')}}</router-link>
                    </li>
                    <li  class="nav-item" :class="[currentPage==='transferts_marchand'?'active':'']">
                        <router-link class="nav-link" :to="{name:'transferts_marchand'}"><i class="mdi mdi-transfer menu-icon"></i>{{$t('menus.transferts_compte_marchand')}}</router-link>
                    </li>
  
                </ul>
            </div>
        </li> -->
      <!--  <li  v-if="$store.getters.auth.role._code==='client' || $store.getters.auth.role._code==='admin'" class="nav-item" :class="[currentPage==='transferts'?'active':'']">
            <router-link class="nav-link"  :to="{name:'transferts_client'}">
                <i class="mdi mdi-bank-transfer menu-icon"></i>
                <span class="menu-title">{{$t('menus.transferts')}}</span>
            </router-link>
        </li> -->

      <li
        v-if="marchandexiste"
        class="nav-item"
        :class="[currentPage === 'usermeanspaiments' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'usermeanspaiments' }">
          <i class="mdi mdi-credit-card menu-icon"></i>
          <span class="menu-title">{{ $t("menus.usermeanspaiments") }}</span>
        </router-link>
      </li>
      <hr
        v-if="
          $store.getters.marchand && $store.getters.marchand._env === 'live'
        "
      />

      <li
        v-if="
          marchandexiste &&
          $store.getters.marchand &&
          $store.getters.marchand._env === 'live'
        "
        class="nav-item"
        :class="[currentPage === 'intramDirect' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'intramDirect' }">
          <i class="mdi mdi-vector-link menu-icon"></i>
          <span class="menu-title">{{ $t("menus.direct") }}</span>
        </router-link>
      </li>
      <li
        v-if="
          marchandexiste &&
          $store.getters.marchand &&
          $store.getters.marchand._env === 'live'
        "
        class="nav-item"
        :class="[currentPage === 'intramBusiness' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'intramBusiness' }">
          <i class="mdi mdi-contactless-payment-circle menu-icon"></i>
          <span class="menu-title">{{ $t("menus.payments") }}</span>
        </router-link>
      </li>

      <li
        v-if="
          marchandexiste &&
          $store.getters.marchand &&
          $store.getters.marchand._env === 'live'
        "
        class="nav-item"
        :class="[currentPage === 'intramScholar' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'intramScholar' }">
          <i class="mdi mdi-school menu-icon"></i>
          <span class="menu-title">{{ $t("menus.scholar") }}</span>
        </router-link>
      </li>
      <hr v-if="$can('browse', 'Services') || $can('browse', 'Ads')" />
      <li
        v-if="$can('browse', 'Services')"
        class="nav-item"
        :class="[currentPage === 'intramServices' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'intramServices' }">
          <i class="mdi mdi-animation-outline menu-icon"></i>
          <span class="menu-title">{{ $t("menus.services") }}</span>
        </router-link>
      </li>
      <li
        v-if="$can('browse', 'Ads')"
        class="nav-item"
        :class="[currentPage === 'intramAds' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'intramAds' }">
          <i class="mdi mdi-email-mark-as-unread menu-icon"></i>
          <span class="menu-title">{{ $t("menus.annonces") }}</span>
        </router-link>
      </li>
      <hr
        v-if="
          $store.getters.marchand && $store.getters.marchand._env === 'live'
        "
      />
      <li
        v-if="this.$store.getters.marchand"
        class="nav-item"
        :class="[currentPage === '' ? 'active' : '']"
      >
        <a
          class="nav-link"
          data-toggle="collapse"
          href="#devMenu"
          aria-expanded="false"
          aria-controls="layoutsSubmenu2"
          style="background: transparent !important"
        >
          <i
            style="color: #0d0a0a !important"
            class="mdi mdi-code-braces menu-icon"
          ></i>
          <span style="color: #0d0a0a !important" class="menu-title">{{
            $t("menus.developers")
          }}</span>
          <i
            style="color: #0d0a0a !important"
            class="mdi mdi-chevron-down menu-arrow"
          ></i>
        </a>
        <div class="collapse" id="devMenu">
          <ul class="nav flex-column sub-menu">
            <li
              class="nav-item"
              :class="[currentPage === 'api' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'api' }">
                <span class="menu-title">
                  <i class="mdi mdi-api menu-icon"></i
                  >{{ $t("menus.api") }}</span
                >
              </router-link>
            </li>
            <li
              class="nav-item"
              :class="[
                currentPage === 'developers.api.documentation' ? 'active' : '',
              ]"
            >
              <a class="nav-link" href="https://docs.intram.org" target="_blank"
                ><span class="menu-title"
                  ><i class="mdi mdi-text-box-multiple-outline menu-icon"></i
                  >{{ $t("menus.api_doc") }}</span
                ></a
              >
            </li>
            <li
              class="nav-item"
              :class="[currentPage === 'developers.journal' ? 'active' : '']"
            >
              <router-link class="nav-link" :to="{ name: 'developers.journal' }"
                ><span class="menu-title"
                  ><i class="mdi mdi-notebook-outline menu-icon"></i
                  >{{ $t("menus.journal") }}</span
                >
              </router-link>
            </li>
          </ul>
        </div>
      </li>
      <li
        class="nav-item"
        :class="[currentPage === 'settings' ? 'active' : '']"
      >
        <router-link class="nav-link" :to="{ name: 'settings' }">
          <i class="mdi mdi-cog menu-icon"></i>
          <span class="menu-title">{{ $t("menus.settings") }}</span>
        </router-link>
      </li>
      <li class="nav-item">
        <a @click.prevent="logout()" class="nav-link" href="#">
          <i class="mdi mdi-logout menu-icon"></i>
          <span class="menu-title">{{ $t("menus.logout") }}</span>
        </a>
      </li>
    </ul>
    <div class="nav-item nav-category topHead text-center pt-2">
      <img v-lazy="'/images/logo_large_white.png'" class="logoDash" alt="" />
    </div>
  </div>
</template>

<script>
import * as Swal from "sweetalert2";
import { mapState } from "vuex";
import { env } from "../../../../env";
export default {
  name: "marchand-sidebar",
  data() {
    return {
      image_url: env.image_base_url,
      profileView: false,
      switch1: false,
      switch2: true,
      marchandexiste: false,
      user: JSON.parse(localStorage.getItem("user")),
      allmarchands: [],
      checked:
        this.$store.getters.marchand &&
        this.$store.getters.marchand._env === "live"
          ? true
          : false,
    };
  },
  computed: {
    currentPage() {
      return this.$route.name;
    },
    ...mapState("marchands/", ["marchandu"]),
  },
  mounted() {
    if (this.$store.getters.marchand) {
      this.marchandexiste = true;
      this.$store.dispatch("marchands/getMarchandUser");
      this.$store.dispatch("marchands/getMarchandByUser").then((response) => {
        this.allmarchands =
          response && response.data && response.data.marchandu
            ? response.data.marchandu
            : {};
      });
    }
  },
  methods: {
    newMarchand() {
      this.$router.push({ name: "newAccountMarchand" });
    },
    goToProfil() {
      if (this.$router.currentRoute !== "/settings") {
        this.$router.push("/settings");
      }
    },
    setProfileVisibility: function () {
      !this.profileView
        ? (this.profileView = true)
        : (this.profileView = false);
    },
    ChangedMarchand(marchandID) {
      /*
                        alert(this.editedItem._marchandID);
        */
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("marchand.change_marchand"),
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        showCancelButton: true,
        confirmButtonColor: "#29B3A6",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("marchands/changeMarchand", marchandID)
            .then(() => {
              Swal.fire({
                icon: "success",
                timer: 3000,
                timerProgressBar: false,
                text: "Changement de compte effectué",
                position: "top-end",
                showConfirmButton: false,
              });
              window.location = window.origin;
            });
        }
      });
    },
    changemode(mode) {
      let marchand = this.$store.getters.marchand;
      let message =
        "Vous êtes sur le point de changé de mode. Êtes vous sûr de vouloir passé en mode " +
        mode +
        " ?";
      let vuebox = this;
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t(message),
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        showCancelButton: true,
        confirmButtonColor: "#29B3A6",
      }).then((result) => {
        if (result.value) {
          vuebox.toast(
            "warning",
            "Changement du mode en " +
              mode +
              " en cours ... Veuillez patienter."
          );
          this.$store
            .dispatch("marchands/mode", marchand._id)
            .then((result) => {
              if (result.error) {
                Swal.fire({
                  icon: "error",
                  timer: 3000,
                  timerProgressBar: false,
                  text: this.$t(result.message),
                  position: "top-end",
                  showConfirmButton: false,
                });
              } else {
                location.reload();
              }
            });
        }
      });
    },
    mode() {
      let message =
        "Veuillez renseigné les informations supplementaires concernant votre compte marchand";
      Swal.fire({
        icon: "error",
        title: "Oops...",
        timerProgressBar: false,
        text: this.$t(message),
        confirmButtonText: "OK",
        confirmButtonColor: "#29B3A6",
      });
    },
    getUserNames() {
      let names = undefined;
      if (
        !(
          this.$store.getters.auth._first_name &&
          this.$store.getters.auth._last_name
        )
      ) {
        if (!this.$store.getters.auth._first_name) {
          if (this.$store.getters.auth._last_name) {
            names = this.$store.getters.auth._last_name;
          }
        } else {
          names = this.$store.getters.auth._first_name;
        }
      } else {
        names =
          this.$store.getters.auth._first_name +
          " " +
          this.$store.getters.auth._last_name;
      }
      return names;
    },
  },
};
</script>

<style scoped>
.menuable__content__active {
  left: 0 !important;
  min-width: 240px !important;
}

.v-list-item__title span {
  font-weight: normal !important;
}

.no-uppercase {
  text-transform: none;
}

.theme--light.v-application {
  background: transparent;
}

#sidebar {
  box-shadow: 0 6px 15px 0 rgba(207, 211, 218, 0.35);
  border-color: #29b3a6;
  position: fixed;
  min-height: 100vh;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 20px;
}

.sidebar .nav {
  max-height: 66vh !important;
  overflow-y: auto;
}
.sidebar #menuNav {
  height: 68vh !important;
}

.sidebar .nav::-webkit-scrollbar {
  border: none;
  box-shadow: none;
}

.sidebar .nav::-webkit-scrollbar-track {
  border: none;
  box-shadow: none;
}

.sidebar .nav::-webkit-scrollbar-track:active,
.sidebar .nav::-webkit-scrollbar-track:focus {
  border: none;
  box-shadow: none;
}

.sidebar .nav::-webkit-scrollbar-track-piece {
  border: none;
  box-shadow: none;
}

.sidebar .nav::-webkit-scrollbar-thumb {
  border-radius: 50px;
  background-image: linear-gradient(#f8f8f8, #29b3a6) !important;
  border: none;
}

ul.nav {
  padding-left: 0;
}

.nav-category {
  background: #29b3a6;
  height: 50px;
  box-shadow: 0 6px 15px 0 rgba(207, 211, 218, 0.35);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.mode_box {
  min-height: 6vh;
}

.marchand-account-change {
  min-height: 9vh;
}

.topHead {
  border: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  min-height: 5vh;
}

.logoDash {
  width: 70px;
}

.user-info {
  border-bottom: 2px solid #f8f8f8;
  text-align: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  min-height: 12vh;
}

.user-info p {
  margin-top: 10px;
}

.logouPanel {
  margin-top: 10px;
}

.secondProfile {
  color: #fff;
  cursor: pointer;
}

.imgProfileSecond {
  height: 40px;
  width: 40px;
  border: 2px solid #fff;
  border-radius: 100%;
  margin-right: 10px;
}

.user-info {
  transition-duration: 200ms;
  border-bottom: 10px solid #29b3a6;
  margin-bottom: 10px;
  cursor: pointer;
}

/* .user-info:hover{
      color: #fff;
      background: #29B3A6;
      border-bottom: 0px solid #006958;
  } */
.nav-link:hover {
  color: #006958;
}

.fa-angle-up:before {
  content: "\f106";
}

.profileDown {
  position: absolute;
  right: 10px;
  color: #fff;
  top: 10px;
  cursor: pointer;
}

.sidebar-dark .sidebar .nav.sub-menu .nav-item .nav-link {
  color: #000;
}

.text-profile {
  padding: 20px 0;
}

.image_profile {
  text-align: center;
  font-weight: bold;
}

.image_profile img {
  width: 0;
}

.role-profile {
  font-size: 10pt;
  color: #d21d19;
}

.sidebar-icon-only:not(.sidebar-expanded)
  .sidebar
  .nav
  .nav-item.hover-open
  .nav-link
  .menu-title {
  background: #fff;
}

@media (max-width: 991px) {
  #sidebar {
    position: absolute;
    height: 100vh;
  }

  .sidebar {
    min-height: 100vh;
  }
}
</style>
